var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _g2, _g3, _g4, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElephant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 316,
    height: 333,
    viewBox: "0 0 316 333",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.0453 22.2316C57.9105 21.7317 57.5971 20.9053 58.105 19.7522L59.7253 16.0732L56.1287 14.4891C55.0305 14.0054 54.7193 13.2236 55.1949 12.1437C55.6705 11.0638 56.4574 10.7657 57.5556 11.2494L61.1522 12.8335L62.7122 9.29183C63.212 8.15703 64.0293 7.83954 65.1641 8.33936C66.2989 8.83917 66.6164 9.65648 66.1166 10.7913L64.5566 14.333L68.1532 15.9171C69.2514 16.4008 69.5627 17.1826 69.0871 18.2625C68.6115 19.3424 67.8245 19.6405 66.7263 19.1568L63.1297 17.5727L61.5094 21.2516C61.0015 22.4047 60.1801 22.7314 59.0453 22.2316ZM70.8498 28.447C70.0444 28.0922 69.5393 27.6512 69.3345 27.1239C69.156 26.5864 69.228 25.9516 69.5505 25.2194C69.7762 24.7069 70.0876 24.2977 70.4846 23.9918C70.8815 23.6859 71.3569 23.4254 71.9105 23.2103L78.9281 20.3022C79.9724 19.8662 80.7619 19.4381 81.2966 19.018C81.8577 18.5876 82.2592 18.0979 82.501 17.5488C83.1137 16.1577 82.5323 15.0712 80.7569 14.2893C80.3176 14.0958 79.8135 13.9502 79.2446 13.8526C78.702 13.7448 78.0917 13.7164 77.4136 13.7674C76.8146 13.7877 76.334 13.6634 75.9716 13.3945C75.6173 13.1073 75.3805 12.7517 75.2613 12.3277C75.1421 11.9037 75.1346 11.4742 75.2388 11.0393C75.3612 10.6124 75.5986 10.2471 75.9509 9.94338C76.3113 9.62132 76.7859 9.43697 77.3746 9.39033C78.4101 9.32188 79.4205 9.3845 80.4061 9.57818C81.418 9.76162 82.3815 10.0549 83.2967 10.458C85.5297 11.4415 87.0183 12.6762 87.7624 14.1622C88.5249 15.6563 88.503 17.3185 87.6968 19.1489C87.1809 20.3203 86.4237 21.3199 85.4254 22.1477C84.427 22.9755 83.0355 23.7285 81.2507 24.4066L76.7423 26.1579L82.2058 28.5643C83.5969 29.177 83.9941 30.1606 83.3976 31.515C82.793 32.8877 81.7951 33.2678 80.4041 32.6551L70.8498 28.447Z",
    fill: "#F4EFFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M266.59 115.651C265.712 115.989 264.953 115.938 264.313 115.499C263.672 115.059 263.385 114.313 263.451 113.259L264.646 95.5687C264.702 94.7115 264.907 94.0214 265.263 93.4987C265.619 92.9759 266.124 92.5888 266.777 92.3373C267.412 92.0931 268.036 92.0455 268.651 92.1947C269.266 92.3439 269.881 92.7178 270.497 93.3164L283.245 105.64C284.026 106.389 284.336 107.138 284.174 107.886C284.005 108.615 283.5 109.142 282.66 109.465C281.913 109.752 281.27 109.807 280.73 109.629C280.209 109.444 279.646 109.039 279.041 108.415L277.326 106.632L268.507 110.027L268.43 112.499C268.382 113.375 268.245 114.049 268.019 114.522C267.794 114.994 267.317 115.371 266.59 115.651ZM268.887 97.9864L268.667 105.432L274.099 103.342L268.943 97.9648L268.887 97.9864ZM295.776 104.481C294.861 104.833 293.946 104.96 293.03 104.863C292.132 104.758 291.371 104.451 290.747 103.942C291.136 105.399 290.603 106.408 289.147 106.968C287.504 107.6 286.36 107.077 285.713 105.397L279.862 90.1941C279.215 88.5142 279.713 87.3582 281.355 86.7259C282.158 86.417 282.857 86.3946 283.451 86.6586C284.064 86.9155 284.529 87.4545 284.845 88.2758L286.903 93.6233C287.065 92.8752 287.442 92.1837 288.034 91.5488C288.644 90.9068 289.378 90.4206 290.237 90.0901C291.431 89.6303 292.588 89.5173 293.707 89.751C294.844 89.9776 295.873 90.5352 296.793 91.4238C297.707 92.2937 298.451 93.4753 299.026 94.9685C299.593 96.443 299.824 97.8221 299.718 99.1059C299.631 100.382 299.241 101.486 298.55 102.417C297.876 103.34 296.952 104.028 295.776 104.481ZM292.796 101.417C293.543 101.129 294.051 100.612 294.321 99.8655C294.591 99.1187 294.488 98.1294 294.014 96.8975C293.533 95.6469 292.945 94.8444 292.252 94.4899C291.551 94.1168 290.827 94.0739 290.081 94.3613C289.315 94.6558 288.798 95.1765 288.528 95.9232C288.251 96.6513 288.353 97.6406 288.835 98.8912C289.309 100.123 289.896 100.926 290.597 101.299C291.298 101.672 292.031 101.711 292.796 101.417ZM311.094 98.5847C309.545 99.181 308.08 99.4126 306.7 99.2794C305.339 99.139 304.133 98.6497 303.081 97.8114C302.03 96.9731 301.217 95.8073 300.642 94.3141C300.067 92.8209 299.893 91.4202 300.118 90.1121C300.336 88.7852 300.906 87.6227 301.829 86.6245C302.764 85.6004 304.005 84.7903 305.555 84.1939C306.096 83.9856 306.687 83.8225 307.327 83.7045C307.96 83.568 308.648 83.5175 309.391 83.5532C309.884 83.556 310.293 83.6987 310.616 83.9815C310.932 84.2456 311.147 84.5809 311.26 84.9872C311.393 85.3864 311.417 85.7841 311.334 86.1804C311.269 86.5696 311.081 86.8884 310.77 87.1369C310.477 87.3782 310.076 87.4788 309.568 87.4388C308.844 87.3959 308.165 87.4966 307.531 87.7408C306.541 88.1216 305.891 88.7148 305.58 89.5205C305.268 90.3261 305.321 91.2702 305.738 92.3528C306.162 93.454 306.763 94.2084 307.541 94.616C308.312 95.0049 309.193 95.009 310.182 94.6282C310.48 94.5133 310.778 94.3667 311.073 94.1886C311.362 93.9918 311.636 93.7577 311.896 93.4862C312.265 93.1085 312.633 92.9239 313.001 92.9324C313.38 92.9151 313.724 93.0291 314.033 93.2746C314.353 93.4942 314.598 93.7964 314.767 94.1812C314.955 94.5588 315.024 94.9608 314.974 95.3873C314.917 95.7951 314.697 96.1692 314.313 96.5096C313.787 97.0339 313.252 97.454 312.709 97.7701C312.174 98.1048 311.635 98.3763 311.094 98.5847Z",
    fill: "#F4EFFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M147.615 424.762C66.0713 428.953 40.0406 372.319 -88.5967 395.849C-191.171 414.609 -235.33 344.567 -248.103 301.052C-254.199 280.262 -255.748 199.002 -199.461 197.841C-8.44031 193.845 144.615 -16.7664 236.706 167.413C274.059 242.13 332.732 415.221 147.615 424.762Z",
    fill: "#F4EFFE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.0134 322.539C90.7514 361.829 125.717 405.789 169.199 406.084C212.697 406.379 248.253 362.911 248.515 323.604C248.777 284.314 213.664 264.063 170.165 263.768C126.667 263.473 91.2755 283.233 90.9971 322.523L91.0134 322.539Z",
    fill: "url(#paint0_linear_0_1)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M221.481 283.501L221.467 283.509C213.292 287.588 209.97 297.525 214.048 305.704L237.484 352.71C241.562 360.888 251.494 364.211 259.669 360.132L259.684 360.124C267.859 356.045 271.18 346.108 267.103 337.929L243.666 290.923C239.589 282.745 229.656 279.422 221.481 283.501Z",
    fill: "url(#paint1_linear_0_1)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108.596 343.134L112.714 341.079C120.889 336.999 124.211 327.062 120.133 318.884L91.3895 261.234C87.3119 253.055 77.3793 249.732 69.2044 253.812L65.0862 255.867C56.9113 259.946 53.5898 269.883 57.6674 278.061L86.4108 335.712C90.4884 343.89 100.421 347.213 108.596 343.134Z",
    fill: "url(#paint2_linear_0_1)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M116.364 157.481L90.1105 141.49C82.0856 136.591 71.9972 136.558 63.9395 141.408C50.3299 149.567 40.094 162.331 35.0825 177.388C26.7628 202.342 37.8994 229.622 61.2863 241.616L87.2936 254.953L116.347 157.481H116.364Z",
    fill: "#9E83FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M111.452 172.276L89.6208 158.988C82.9389 154.925 74.5536 154.892 67.8553 158.923C56.5549 165.706 48.0387 176.323 43.8788 188.824C36.9675 209.567 46.2208 232.244 65.6771 242.222L87.2952 253.314L111.452 172.276Z",
    fill: "url(#paint3_linear_0_1)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M207.586 157.481L233.839 141.49C241.864 136.591 251.952 136.558 260.01 141.408C273.603 149.567 283.839 162.331 288.851 177.372C297.17 202.326 286.034 229.606 262.647 241.599L236.639 254.936L207.586 157.465V157.481Z",
    fill: "#9E83FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M212.499 172.276L234.33 158.988C241.012 154.925 249.397 154.892 256.096 158.923C267.396 165.706 275.912 176.323 280.072 188.824C286.983 209.567 277.73 232.244 258.274 242.222L236.656 253.314L212.499 172.276Z",
    fill: "url(#paint4_linear_0_1)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.595 234.931C249.595 283.347 210.371 305.057 161.976 305.057C113.581 305.057 74.3569 283.347 74.3569 234.931C74.3569 186.514 128.37 134.526 161.976 134.526C195.582 134.526 249.595 186.514 249.595 234.931Z",
    fill: "url(#paint5_linear_0_1)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.321 140.769C151.051 146.7 151.182 163.969 151.182 163.969C151.362 164.559 152.198 164.362 152.476 164.182C153.672 163.412 156.423 160.053 156.423 160.053C156.767 159.562 157.504 159.676 157.7 160.233C157.7 160.233 159.518 166.492 159.928 172.112C159.96 172.473 161.041 172.276 161.32 172.08C163.924 170.195 166.118 159.857 166.118 159.857C166.282 159.283 167.003 159.136 167.379 159.578C167.379 159.578 170.327 160.922 171.867 164.952C171.981 165.264 172.899 164.854 173.144 164.625C178.041 160.135 181.022 143.128 177.353 137.836C172.145 130.315 136.148 135.247 143.321 140.752V140.769Z",
    fill: "#8058EA"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.8011 283.511L90.1605 279.563C91.1922 276.564 94.6315 274.926 97.4484 276.368C97.6449 276.466 104.229 285.051 108.388 287.263C112.958 289.705 121.097 288.754 127.091 280.808C135.051 270.256 133.888 255.887 139.391 249.153C149.07 237.339 162.974 236.799 173.751 243.467C184.511 250.136 188.9 265.029 183.937 276.777C178.991 288.492 157.472 304.909 146.007 310.267C131.939 316.854 116.151 312.446 108.896 308.547C97.3174 302.337 88.5063 291.31 88.5063 291.31C85.1654 288.967 86.6557 285.625 88.8011 283.511Z",
    fill: "url(#paint6_linear_0_1)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M127.877 248.989C141.897 248.989 153.262 234.318 153.262 216.22C153.262 198.122 141.897 183.451 127.877 183.451C113.857 183.451 102.492 198.122 102.492 216.22C102.492 234.318 113.857 248.989 127.877 248.989Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M198.3 248.989C212.32 248.989 223.685 234.318 223.685 216.22C223.685 198.122 212.32 183.451 198.3 183.451C184.281 183.451 172.916 198.122 172.916 216.22C172.916 234.318 184.281 248.989 198.3 248.989Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M145.893 213.664C145.893 207.33 140.761 202.195 134.429 202.195C128.098 202.195 122.965 207.33 122.965 213.664V225.133C122.965 231.467 128.098 236.602 134.429 236.602C140.761 236.602 145.893 231.467 145.893 225.133V213.664Z",
    fill: "#122431"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M131.973 218.579C135.139 218.579 137.705 216.012 137.705 212.844C137.705 209.677 135.139 207.11 131.973 207.11C128.807 207.11 126.241 209.677 126.241 212.844C126.241 216.012 128.807 218.579 131.973 218.579Z",
    fill: "#FEFFFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M203.214 213.664C203.214 207.33 198.082 202.195 191.75 202.195C185.419 202.195 180.286 207.33 180.286 213.664V225.133C180.286 231.467 185.419 236.602 191.75 236.602C198.082 236.602 203.214 231.467 203.214 225.133V213.664Z",
    fill: "#122431"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M189.294 218.579C192.459 218.579 195.026 216.012 195.026 212.844C195.026 209.677 192.459 207.11 189.294 207.11C186.128 207.11 183.562 209.677 183.562 212.844C183.562 216.012 186.128 218.579 189.294 218.579Z",
    fill: "#FEFFFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M221.229 260.114C219.608 269.469 210.584 277.088 199.005 279.284",
    stroke: "white",
    strokeWidth: 9,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 82.9971,
    y: 258.764,
    width: 173.519,
    height: 158.321,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_0_1",
    x: 66.3569,
    y: 129.526,
    width: 191.238,
    height: 186.531,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_0_1",
    x: 140.379,
    y: 133,
    width: 40.6099,
    height: 42.3132,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_0_1",
    x: 78.5439,
    y: 234.18,
    width: 115.428,
    height: 90.4656,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 169.77,
    y1: 263.794,
    x2: 169.784,
    y2: 406.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#AD95FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 229.035,
    y1: 281.14,
    x2: 226.075,
    y2: 359.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 99.7227,
    y1: 345.37,
    x2: 103.155,
    y2: 253.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_1",
    x1: 111.452,
    y1: 204.619,
    x2: 41.6023,
    y2: 204.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_1",
    x1: 212.499,
    y1: 204.619,
    x2: 282.349,
    y2: 204.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_0_1",
    x1: 161.976,
    y1: 305.057,
    x2: 161.976,
    y2: 134.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_0_1",
    x1: 175.084,
    y1: 243.351,
    x2: 105.641,
    y2: 309.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A990FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#BBA6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#C5B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElephant);
export default __webpack_public_path__ + "static/media/elephant.3400a449ac34f1cd1b4a516e2fbdac14.svg";
export { ForwardRef as ReactComponent };